import { FC, memo } from "react";
import { Chip } from "@mui/material";
import { VerificationAppDocumentType } from "../../models";
import { STEP_TYPE_LABELS } from "./helpers";

export const StepTypeChip: FC<{ type: VerificationAppDocumentType }> = memo(
  ({ type }) => <Chip label={STEP_TYPE_LABELS[type] ?? type} size='small' />,
);
